import ConfigForm, { ConfigInput } from "components/Layout/ConfigForm";
import React from "react";

export interface BarcodeDetailsProps {
  handleTaskItemNameChange: (event: any) => void;
  name: string;
}

function BarcodeDetails({
  name,
  handleTaskItemNameChange,
}: BarcodeDetailsProps) {
  const inputs: ConfigInput[] = [
    {
      required: true,
      title: "Prompt",
      type: "text",
      onChange: handleTaskItemNameChange,
      xs: 12,
      sm: 6,
      id: "taskItemName",
      value: name,
    },
  ];
  return (
    <ConfigForm title="Configure Barcode Scan" inputs={inputs}></ConfigForm>
  );
}

export default BarcodeDetails;
